import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//Fonction de récupération des bons de prélèvements
async function getUsers(){
	try {
        this.users = await requestApi({method: 'GET', url: '/api/getAllUsers?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
	} catch (error) {
        if(error.response != undefined){
			toasterError(`Impossible de récupérer les utilisateurs`,'Utilisateurs')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
    }
}

//Fonction de récupération des bons de prélèvements
async function generatePdf(id,date){
	try {
        let inters = await requestApi({method: 'POST', url: '/api/getExtractTime?nocache=' + new Date().getTime(), params: {}, form: {id:id,date:date}, headers: {'Content-Type': 'application/json'}})
        let intersFact = await requestApi({method: 'POST', url: '/api/getExtractTimeFact?nocache=' + new Date().getTime(), params: {}, form: {id:id,date:date}, headers: {'Content-Type': 'application/json'}})
		await requestApi({method: 'GET', url: '/api/downloadExportTime/'+inters.name+'?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
		var element = document.createElement('a')
		element.setAttribute('href', '/api/downloadExportTime/'+inters.name)

		element.style.display = 'none'
		document.body.appendChild(element)

		element.click()

		document.body.removeChild(element)

		await requestApi({method: 'GET', url: '/api/downloadExportTime/'+intersFact.name+'?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
		var element = document.createElement('a')
		element.setAttribute('href', '/api/downloadExportTime/'+intersFact.name)

		element.style.display = 'none'
		document.body.appendChild(element)

		element.click()

		document.body.removeChild(element)
	} catch (error) {
        if(error.response != undefined){
			toasterError(`Impossible de récupérer les lignes du bon de prélèvement`,'Lignes des bons')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
    }
}

//Fonction de récupération des bons de prélèvements
// async function generatePdf(id,dateCred,nomBon){
// 	try {
//         let name = await requestApi({method: 'GET', url: '/api/getExportPrelevement?nocache=' + new Date().getTime(), params: {id:id,dateCred:dateCred,nomBon:nomBon}, form: {}, headers: {'Content-Type': 'application/json'}})
//     	// await requestApi({method: 'GET', url: '/api/downloadExportPrelevement/'+name+'?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
// 		var element = document.createElement('a')
// 		element.setAttribute('href', '/api/downloadExportPrelevement/'+name)

// 		element.style.display = 'none'
// 		document.body.appendChild(element)

// 		element.click()

// 		document.body.removeChild(element)
// 	} catch (error) {
//         if(error.response != undefined){
// 			toasterError(`Impossible de récupérer les lignes du bon de prélèvement`,'Lignes des bons')
// 		}else{
// 			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
// 		}
//     }
// }

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default{
	getUsers,
	generatePdf
}

